export function useNormalizeUrl() {
  const normalizeUrl = (input: string): string => {
    if (!input) return "";
    const trimmed = input.trim();
    return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  };

  return { normalizeUrl };
}
